export default __webpack_public_path__ + "static/media/saveCatalogId.2bc7a0a5.svg";